import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { GdsImageKeys } from '@upr-gds-web/components';
import * as i2 from '@upr-web-primer/gds-button-model-service';
import * as i5 from '@upr-web-primer/gds-common-utility';
import * as i4 from '@upr-web-primer/gds-image-link-model';
import * as i1 from '@upr-web-primer/gds-picture-model';
import * as i3 from '@upr-web-primer/gds-video-model';
import * as i6 from '@upr-web-primer/locale';
import { get, forEach, isEmpty, set, isArray } from 'lodash-es';
class GdsDataModelModule {
  static {
    this.ɵfac = function GdsDataModelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDataModelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsDataModelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDataModelModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsDataModelService {
  /**
   * Creates an instance of upr tridion to gds data model service.
   * @param tridionDefaults
   * @param appDefaults
   * @param pictureDataMapper
   * @param buttonDataMapper
   * @param videoDataMapper
   * @param localeService
   */
  constructor(tridionDefaults, appDefaults, pictureDataMapper, buttonDataMapper, videoDataMapper, imageLinkDataMapper, util, localeService) {
    this.tridionDefaults = tridionDefaults;
    this.appDefaults = appDefaults;
    this.pictureDataMapper = pictureDataMapper;
    this.buttonDataMapper = buttonDataMapper;
    this.videoDataMapper = videoDataMapper;
    this.imageLinkDataMapper = imageLinkDataMapper;
    this.util = util;
    this.localeService = localeService;
    const locale = this.localeService.getFromStorage();
    this.language = locale.language || get(this.appDefaults, 'DEFAULT_ROUTE_COUNTRY');
    this.country = locale.country || get(this.appDefaults, 'DEFAULT_ROUTE_LANGUAGE');
    this.site = get(this.tridionDefaults, 'TRIDION_SITE');
    this.siteWithLocale = [this.site, this.language, this.country].join('/');
    this.currencySymbol = get(this.appDefaults, 'DEFAULT_CURRENCY_SYMBOL');
    this.currencyBypass = get(this.appDefaults, 'DEFAULT_CURRENCY_BYPASS');
  }
  /**
   * Inits upr tridion to gds data model service
   * @param data
   * @returns init
   */
  init(data) {
    let dataModel = {};
    forEach(data, field => {
      dataModel = this.parseField(field, dataModel);
    });
    return dataModel;
  }
  fetchContentIds(data) {
    const contentIds = [];
    forEach(data, field => {
      const contentId = get(field, 'MetadataFields.contentId.Values[0]');
      contentIds.push(contentId);
    });
    return contentIds;
  }
  /**
   * Inits upr tridion xpm fields to gds xpm data model service
   * @param data
   * @returns initXpmFields
   */
  initXpmFields(data) {
    let xpmDataModel = {};
    forEach(data, field => {
      xpmDataModel = this.parseXpmField(field, xpmDataModel);
    });
    return xpmDataModel;
  }
  /**
   * Resolves links in text
   * @param text
   * @returns links in text
   */
  resolveLinksInText(text) {
    if (!text || text.indexOf('href') <= 0) {
      return text;
    }
    return text.replace('href="/' + this.siteWithLocale, 'href="' + this.siteWithLocale.replace(this.site + '/', ''));
  }
  getKeyMetadataFieldsAndParentKeywords(value) {
    const metadataFields = get(value, '0.MetadataFields');
    const parentKeywords = get(value, '0.ParentKeywords[0].Key', null);
    const fields = {};
    if (metadataFields && !isEmpty(metadataFields)) {
      fields.MetadataFields = metadataFields;
    }
    if (parentKeywords && !isEmpty(parentKeywords)) {
      fields.parentKeywords = parentKeywords;
    }
    return fields && !isEmpty(fields) ? {
      ...fields,
      Key: value[0].Key
    } : value[0].Key;
  }
  parseXpmField(field, dataModel) {
    return this.parseField(field, dataModel, undefined, true);
  }
  parseField(field, dataModel, parentKey, isXpmField) {
    let _key = get(field, 'Name');
    let _value = get(field, 'Values');
    const xPath = get(field, 'XPath');
    if (isXpmField) {
      _value = xPath;
    }
    const fieldType = get(field, 'FieldType');
    if (_key && _value) {
      switch (fieldType) {
        case 0:
          // single text field
          _value = _value.length > 1 ? _value : _value[0];
          dataModel[_key] = _value;
          break;
        case 1: // multi line text field
        case 2:
          //rtf text field
          _value = _value.length > 1 ? _value : _value[0];
          _value = this.resolveLinksInText(_value);
          dataModel[_key] = _value;
          break;
        case 3:
          //keyword
          _value = get(field, 'KeywordValues');
          _value = _value.length > 1 ? _value : this.getKeyMetadataFieldsAndParentKeywords(_value);
          dataModel[_key] = _value;
          break;
        case 4:
          //embeded field
          const lowerCaseKey = _key.toLowerCase();
          if (['imagebutton', 'styles'].includes(lowerCaseKey)) {
            _value = this.imageLinkDataMapper.init(field, isXpmField);
            dataModel[_key] = _value;
          } else if (lowerCaseKey.includes('image') || lowerCaseKey === 'picture' || lowerCaseKey === 'poster') {
            _value = this.pictureDataMapper.init(field, isXpmField);
            dataModel[_key] = _value;
          } else if (lowerCaseKey.includes('video')) {
            _value = this.videoDataMapper.init(field, isXpmField);
            dataModel[_key] = _value;
          } else if (lowerCaseKey.includes('button') || lowerCaseKey.includes('cta') || lowerCaseKey.includes('link')) {
            // Change _key to 'buttons' for multi buttons.
            const embeddedValues = get(field, `EmbeddedValues`);
            if (embeddedValues.length > 1 && _key === 'button') {
              _key = 'buttons';
            }
            _value = this.buttonDataMapper.init(field, _key === 'mediaButton',
            //TODO : FIX USAGE AND REMOVE
            _key === 'buttons',
            //TODO : FIX USAGE AND REMOVE
            isXpmField);
            if (_key !== 'mediaButton' && !isEmpty(_value)) {
              dataModel[_key] = _value;
            } else if (!isEmpty(_value)) {
              //TODO: FIND USAGE, FIX AND REMOVE
              dataModel['button'] = _value;
            }
          } else if (get(field, 'EmbeddedValues', false)) {
            const embeddedValues = get(field, 'EmbeddedValues', []);
            forEach(embeddedValues, (embeddedValue, key) => {
              let embeddedModel = {};
              forEach(embeddedValue, modelValue => embeddedModel = this.parseField(modelValue, embeddedModel, key, isXpmField));
              const fieldName = get(field, 'Name');
              if (embeddedValues.length > 1) {
                if (Number(key) === 0) {
                  dataModel[fieldName] = [];
                }
                dataModel[fieldName].push(embeddedModel);
              } else {
                if (lowerCaseKey.endsWith('price')) {
                  embeddedModel['currencySymbol'] = this.currencySymbol;
                  embeddedModel['currencyBypass'] = this.currencyBypass;
                }
                dataModel[fieldName] = embeddedModel;
              }
            });
          }
          break;
        case 5:
          if (['iconImage', 'landLogo'].includes(field.Name)) {
            _value = this.imageLinkDataMapper.init(field, isXpmField);
            dataModel[_key] = _value;
          }
          break;
        case 6:
          const linkedComponentValues = get(field, 'LinkedComponentValues', false);
          if (linkedComponentValues) {
            forEach(linkedComponentValues, (linkedComponent, key) => {
              let embeddedModel = {};
              const cardTypeObj = get(linkedComponent, 'MetadataFields.card_type', {});
              const venueObj = get(linkedComponent, 'MetadataFields.VenueID', {});
              const googleCalendarLinkObj = get(linkedComponent, 'MetadataFields.GoogleCalendarLink', {});
              const personaObj = get(linkedComponent, 'MetadataFields.Persona', {});
              let linkedComponentFields = get(linkedComponent, 'Fields', {});
              linkedComponentFields = set(linkedComponentFields, 'card_type', cardTypeObj);
              linkedComponentFields = set(linkedComponentFields, 'VenueID', venueObj);
              linkedComponentFields = set(linkedComponentFields, 'GoogleCalendarLink', googleCalendarLinkObj);
              linkedComponentFields = set(linkedComponentFields, 'Persona', personaObj);
              if (parentKey === _key) {
                console.log('SAME KEY');
              }
              const fieldName = get(field, 'Name');
              if (_key === 'field' && linkedComponent?.Schema?.RootElementName?.toLowerCase().includes('gdsformbutton')) {
                linkedComponent.EmbeddedValues = [linkedComponent.Fields];
                linkedComponent.Name = 'button';
                linkedComponent.FieldType = 4;
                linkedComponent.Values = 'true';
                this.parseField(linkedComponent, embeddedModel, _key, isXpmField);
                dataModel[fieldName] = {
                  ...embeddedModel.button
                };
                return;
              }
              forEach(linkedComponentFields, modelValue => embeddedModel = this.parseField(modelValue, embeddedModel, _key, isXpmField));
              if (linkedComponentValues.length > 1) {
                if (Number(key) === 0) {
                  dataModel[fieldName] = [];
                }
                dataModel[fieldName].push(embeddedModel);
              } else {
                dataModel[fieldName] = embeddedModel;
              }
            });
          }
          break;
        default:
          dataModel[_key] = _value;
          break;
      }
    }
    return dataModel;
  }
  /**
   * This method is used to parse the data for image/cta for any gds component
   * @memberof GdsDataModelService
   * @public
   * @param {any} gds-component-Content
   * @returns {any} parsedData for image & button GdsPictureData/GdsButtonData
   **/
  parseContent(componentContent) {
    const dataParsed = get(componentContent, 'parsed', false);
    if (dataParsed) {
      return componentContent;
    }
    for (const key in componentContent) {
      this.imageOrCta(componentContent, key);
      if (['items', 'sections'].includes(key) && isArray(componentContent[key])) {
        componentContent[key].forEach(item => {
          this.parseContent(item);
        });
      }
    }
    Object.assign(componentContent, {
      parsed: true
    });
    return componentContent;
  }
  /**
   * This method is invoked from public method parseContent for various key values of data to parse them as image/cta
   * @memberof GdsDataModelService
   * @params {any} gds component data & key {string} for which data to be parsed
   * @private
   **/
  imageOrCta(componentData, key) {
    if (componentData.hasOwnProperty(key)) {
      if (['button', 'link', 'ctaButton', 'previousButton', 'nextButton'].includes(key)) {
        componentData[key] = this.buttonDataMapper.mapButtonData(componentData[key]);
        return;
      }
      if (['buttons', 'imageButton'].includes(key)) {
        componentData[key] = [].concat(this.buttonDataMapper.mapButtonData(componentData[key]));
        return;
      }
      if (['profileButton'].includes(key)) {
        componentData[key] = [].concat(this.buttonDataMapper.mapProfileButtonData(componentData[key]));
        return;
      }
      if (['profileButton'].includes(key)) {
        componentData[key] = [].concat(this.buttonDataMapper.mapProfileButtonData(componentData[key]));
        return;
      }
      if (['profileToggleButton'].includes(key)) {
        componentData[key] = [].concat(this.buttonDataMapper.mapProfileToggleButtonData(componentData[key]));
        return;
      }
      // GdsImageKeys are exported from @upr-gds-web/components to return GdsPictureData
      if (GdsImageKeys.includes(key) && typeof componentData[key] === 'object') {
        componentData[key] = this.pictureDataMapper.init(componentData[key][0] || componentData[key]);
      }
      if (GdsImageKeys.includes(key) && typeof componentData[key] === 'string') {
        componentData[key] = this.util.resolveImagePath(componentData[key]);
      }
      if (key === 'price') {
        if (Array.isArray(componentData[key]) && componentData[key].length > 1) {
          componentData[key] = componentData[key].map(price => ({
            ...price,
            currencySymbol: this.currencySymbol,
            currencyBypass: this.currencyBypass
          }));
        } else {
          componentData[key] = componentData[key][0] || componentData[key];
          componentData[key]['currencySymbol'] = this.currencySymbol;
          componentData[key]['currencyBypass'] = this.currencyBypass;
        }
      }
      // For offer-card in a swimlane
      if (key === 'badge') {
        componentData[key] = componentData[key][0] || componentData[key];
        if (componentData[key].hasOwnProperty('price')) {
          componentData[key]['price'] = componentData[key]['price'][0] || componentData[key]['price'];
          componentData[key]['price']['currencySymbol'] = this.currencySymbol;
          componentData[key]['price']['currencyBypass'] = this.currencyBypass;
        }
      }
      // for cf3 mini
      if (key === 'contentBackground') {
        componentData[key] = componentData[key][0];
        if (componentData[key].hasOwnProperty('buttons')) {
          componentData[key]['buttons'] = [].concat(this.buttonDataMapper.mapButtonData(componentData[key]['buttons']));
        }
      }
    }
  }
  static {
    this.ɵfac = function GdsDataModelService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDataModelService)(i0.ɵɵinject('TridionDefaults'), i0.ɵɵinject('AppDefaults'), i0.ɵɵinject(i1.GdsPictureModelService), i0.ɵɵinject(i2.GdsButtonModelService), i0.ɵɵinject(i3.GdsVideoModelService), i0.ɵɵinject(i4.GdsImageLinkModelService), i0.ɵɵinject(i5.GdsCommonUtilityService), i0.ɵɵinject(i6.LocaleService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsDataModelService,
      factory: GdsDataModelService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDataModelService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['TridionDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: i1.GdsPictureModelService
  }, {
    type: i2.GdsButtonModelService
  }, {
    type: i3.GdsVideoModelService
  }, {
    type: i4.GdsImageLinkModelService
  }, {
    type: i5.GdsCommonUtilityService
  }, {
    type: i6.LocaleService
  }], null);
})();

/*
 * Public API Surface of gds-data-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsDataModelModule, GdsDataModelService };
